<template lang="pug">
  bloco.-nomargin.-softpadding
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Contatos
    //- CONTENT
    .texto(slot="content")
      slot
</template>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import Titulo from 'COMPONENTS/ElementTitle'
  import Listagem from 'COMPONENTS/BaseLista'

  export default {

    components: {
      Bloco,
      Titulo,
      Listagem
    }

  }
</script>



// WEBPACK FOOTER //
// HotsiteContato.vue?2f5782b0